import { Link } from "react-router-dom";
import Container from "@/components/Container/Container";
import { primaryNav, site } from "@/content/site";
import styles from "./Footer.module.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <Container width="default" className={styles.inner}>
        <div className={styles.brandCol}>
          <Link to="/" className={styles.brand}>
            {site.practitioner.fullTitle}
          </Link>
          <p className={styles.tagline}>{site.tagline}</p>
          <p className={styles.note}>{site.practitioner.location}</p>
          <a
            href={site.links.psychologyTodayProfile}
            className={styles.ptBadge}
            target="_blank"
            rel="noopener noreferrer"
            title="Lea Walchshauser"
            aria-label="Verified by Psychology Today — Lea Walchshauser"
          >
            <img
              src="/images/psychology-today-verified.svg"
              alt="Verified by Psychology Today"
              width={284}
              height={89}
              loading="lazy"
            />
          </a>
        </div>

        <div className={styles.linksCol}>
          <h4 className={styles.colHeader}>Explore</h4>
          <ul className={styles.linkList}>
            {primaryNav.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className={styles.link}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.linksCol}>
          <h4 className={styles.colHeader}>Resources</h4>
          <ul className={styles.linkList}>
            <li>
              <a
                href={site.links.headway}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                Headway (insurance)
              </a>
            </li>
            <li>
              <a
                href={site.links.psychologyToday}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                Psychology Today
              </a>
            </li>
            <li>
              <a
                href={site.links.brainspottingDirectory}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                Brainspotting Directory
              </a>
            </li>
            <li>
              <a
                href={site.links.linkedIn}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </Container>

      <div className={styles.bottomBar}>
        <Container width="default" className={styles.bottomInner}>
          <p className={styles.copy}>
            &copy; {year} {site.practitioner.fullTitleWithLicense}. All rights reserved.
          </p>
          <p className={styles.disclaimer}>
            This site is for informational purposes only and does not constitute a therapeutic
            relationship.
          </p>
        </Container>
      </div>
    </footer>
  );
}
